package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic

@Serializable
internal sealed interface MealPlanResponseDto {

    @Serializable
    @SerialName("processing")
    data class Processing(val data: ProcessingData) : MealPlanResponseDto {
        @Serializable
        data class ProcessingData(val message: String)
    }

    @Serializable
    @SerialName("error")
    data class Error(val data: ErrorData) : MealPlanResponseDto {
        @Serializable
        data class ErrorData(val message: String, val action: String)
    }

    @Serializable
    @SerialName("ready")
    data class Ready(val data: MealPlanDataDto) : MealPlanResponseDto

    companion object {
        val module = SerializersModule {
            polymorphic(MealPlanResponseDto::class) {
                subclass(Processing::class, Processing.serializer())
                subclass(Error::class, Error.serializer())
                subclass(Ready::class, Ready.serializer())
            }
        }
    }
}
